import { useEffect, useState } from "react";
import { debounce } from "lodash";

export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const update = debounce((next: T) => setDebounced(next), delayMs);
    update(value);
    return () => update.cancel();
  }, [value, delayMs]);

  return debounced;
}
